import Vue from 'vue'
import Vuex from 'vuex'
import { getMyself, getProductList } from '../services/interface'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    permissions: [],
    email: '',
    user: {}, // 账号信息
    product: [],
    productLoading: false
  },
  mutations: {
    login (state, d) {
      state.isLogin = d
    },
    getPermissions (state, list) {
      state.permissions = list
    },
    getEmail (state, email) {
      state.email = email
    },
    getUser (state, user) {
      state.user = user
    },
    getProduct (state, product) {
      state.product = product
    },
    getProductLoading (state, loading) {
      state.productLoading = loading
    }
  },
  actions: {
    async init ({ state, commit }) {
      if (!state.isLogin) {
        await getMyself().then((res) => {
          if (res.status === 200) {
            commit('login', true)
            commit('getPermissions', res.data.permissions)
            commit('getEmail', res.data.email)
            commit('getUser', res.data)
          }
        }).catch(() => {

        })
      }
    },
    getProductData ({ state, commit }) {
      if (!state.productLoading) {
        const params = { forceall: 1 }
        getProductList(params).then((res) => {
          if (res.status === 200) {
            const product = res.data.datas || []
            commit('getProduct', product)
            commit('getProductLoading', true)
          }
        }).catch(() => {

        })
      }
    }
  },
  modules: {
  }
})
